import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  type OrganisationStatus,
  ORGANISATION_STATUS_MAP,
} from '@principle-theorem/principle-core/interfaces';
import { StatusLabelComponent } from '../status-label/status-label.component';

@Component({
  selector: 'pr-organisation-status',
  templateUrl: './organisation-status.component.html',
  styleUrls: ['./organisation-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StatusLabelComponent],
})
export class OrganisationStatusComponent {
  @Input() status: OrganisationStatus;
  statusColourMap: {
    [key in OrganisationStatus]: string;
  } = ORGANISATION_STATUS_MAP;
  @Input({ transform: coerceBooleanProperty }) dense = false;
}
